import { Event, DetailedShift } from '@amzn/red-velvet-api';
import { DISPLAY_EVENT_ATTRIBUTES_TYPE, EventInfo } from '../../events/eventInfo';
interface EventCardProps {
  event: Event;
  detailedShifts?: DetailedShift[];
  displayAttributes: DISPLAY_EVENT_ATTRIBUTES_TYPE[];
}

export function EventCard({ event, detailedShifts, displayAttributes }: EventCardProps) {
  return (
    <EventInfo
      event={event}
      detailedShifts={detailedShifts}
      displayAttributes={displayAttributes}
    />
  );
}
